var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "public-foot" } }, [
    _c("footer", { staticClass: "foots" }, [
      _c("div", { staticClass: "foot-btn", on: { click: _vm.backtop } }, [
        _vm._v("返回榜单主页")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }